"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M11 10.9998v2H9v2h2v2h2v-2h2v-2h-2v-2h-2z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4663 6.9998H6.6294L9.5685 3.229 7.9911 1.9995 4.0936 6.9998H2v2h1.153l2 11.9999h13.6942l2-11.9999H22v-2h-1.9979l-3.8975-5.0003-1.5774 1.2295 2.9391 3.7708zm1.3533 2H5.1806l1.6666 9.9999h10.3057l1.6667-9.9999z"
  })];
};

exports.default = _default;